import { useFetchInsiIdentityAttributesLazyQuery } from 'apps/ids/src/app/api/queries/__generated__/InsiIdentityAttributes.gql'

export const useFetchInsiAttributes = () => {
    const [fetchInsiAttributes] = useFetchInsiIdentityAttributesLazyQuery()

    return async (selectedCodes: number[]) => {
        const response = await fetchInsiAttributes()
        const attributes = new Map(
            response.data?.insiIdentityAttributes?.edges?.map((item) => {
                if (item?.__typename !== 'InsiIdentityAttributesEdge')
                    throw new Error('unexpected node returned, not InsiIdentityAttributesEdge')
                return [parseInt(item.node?.code ?? ''), item.node]
            }),
        )

        return selectedCodes.map((code) => {
            const node = attributes.get(code)
            if (!node) throw new Error('InsiIdentityAttribute code not found amongst fetched nodes!')
            return {
                __typename: 'InsiIdentityAttributes' as const,
                id: node.id ?? '',
                objectId: node.objectId ?? '',
                label: node.label ?? '',
                code: node.code ?? '',
            }
        })
    }
}
